import { Box } from '@ally/metronome-ui'
import React from 'react'

interface WidgetTitleProps {
  title: string
}

const WidgetTitle: React.FC<WidgetTitleProps> = ({ title }) => {
  return (
    <Box
      lineHeight="24px"
      display="block"
      white-space="nowrap"
      align-items="center"
    >
      {title}
    </Box>
  )
}

export default WidgetTitle
